import script from "./CustomEditableNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomEditableNode.vue?vue&type=script&lang=ts&setup=true"

import "./CustomEditableNode.vue?vue&type=style&index=0&id=8ff49894&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff49894"]])

export default __exports__